import React from "react";
import Tooltip from "./Tooltip";

function TextInput({ customInput }) {
  const handleChange = (event) => {
    let inputValue = event.target.value;

    if (maskType) {
      // Remove all non-digit characters
      const rawInputValue = inputValue.replace(/\D/g, "");

      if (maskType === "ssn") {
        // Apply the mask for SSN format
        if (rawInputValue.length > 3 && rawInputValue.length <= 5) {
          inputValue = `${rawInputValue.slice(0, 3)}-${rawInputValue.slice(3)}`;
        } else if (rawInputValue.length > 5) {
          inputValue = `${rawInputValue.slice(0, 3)}-${rawInputValue.slice(
            3,
            5
          )}-${rawInputValue.slice(5)}`;
        } else {
          inputValue = rawInputValue;
        }
      } else if (maskType === "phone") {
        // Apply the mask for phone number format
        if (rawInputValue.length > 3 && rawInputValue.length <= 6) {
          inputValue = `${rawInputValue.slice(0, 3)}-${rawInputValue.slice(
            3,
            6
          )}`;
        } else if (rawInputValue.length > 6) {
          inputValue = `${rawInputValue.slice(0, 3)}-${rawInputValue.slice(
            3,
            6
          )}-${rawInputValue.slice(6)}`;
        } else {
          inputValue = rawInputValue;
        }
      }
    }

    // Call the action prop with the masked value
    action({ ...event, target: { ...event.target, value: inputValue } });
  };

  const {
    type,
    label,
    name,
    value,
    action,
    tooltipBool,
    tooltipText,
    disabled,
    maskType,
    ...props
  } = customInput;

  return (
    <>
      <label htmlFor={name}>
        {label}
        {tooltipBool === true && <Tooltip text={tooltipText}></Tooltip>}
      </label>
      <input
        type={type ?? "text"}
        name={name}
        value={value}
        onChange={maskType ? handleChange : action}
        disabled={disabled}
        {...props}
      />
    </>
  );
}

export default TextInput;
